<template>
  <div class="card">
<!--    <div class="card__header">关联车次</div>-->
    <div class="car-list" v-if="planCarsList.length">
      <div
        v-for="item in planCarsList"
        :key="item.id"
        class="car-item"
        :class="{ active: selectedCar === item.id }"
        @click="handleSelect(item)"
      >
        <div class="car-item__header">
          <div class="driver-name">{{ item.driverName || '火车' }}</div>
<!--          <span class="status-tag" :class="`status-tag&#45;&#45;${getStatusType(item.status)}`">
            {{ getStatusLabel(item.status) }}
          </span> -->
        </div>
        <div class="car-meta phone">{{ item.phoneNo || '--' }}</div>
        <div class="car-meta license">
          <i class="el-icon-truck"></i>
          <span>{{ item.trainNumber || '--' }}</span>
        </div>
      </div>
    </div>
    <div class="car-empty" v-else>暂无车次数据</div>
  </div>
</template>

<script>
export default {
  inject: ["_parentThis"],
  computed: {
    planCarsList () {
      return Array.isArray(this._parentThis.planCarsList)
        ? this._parentThis.planCarsList
        : [];
    }
  },
  data () {
    return {
      selectedCar: ''
    };
  },
  mounted () { },
  methods: {
    getStatusLabel (status) {
      const map = {
        '0': '未开始',
        '1': '进行中',
        '2': '已完成'
      };
      return map[status + ''] || status || '--';
    },
    getStatusType (status) {
      const map = {
        '0': 'warning',
        '1': 'processing',
        '2': 'success'
      };
      return map[status + ''] || 'default';
    },
    handleSelect (item) {
      this.selectedCar = item.id;
      this._parentThis.getPlanTimeline(item.id, item.businessType, item.trainNumber);
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  width: 100%;
  height: 100%;
  min-height: 0;
  border-radius: 2px;
  padding: 18px 5px 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  &__header {
    font-size: 16px;
    font-weight: 600;
    color: #1f2b4d;
    margin-bottom: 14px;
  }
}

.car-list {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;

  .car-item {
    border-radius: 4px;
    //background: #f5f8ff;
    border: 1px solid #D8DEEA;
    padding: 14px 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    transition: all 0.2s ease;
    cursor: pointer;

    //&:hover {
    //  box-shadow: 0 12px 26px -24px rgba(31, 43, 77, 0.6);
    //  transform: translateY(-2px);
    //}

    &.active {
      //border-color: rgba(61, 104, 255, 0.6);
      //background: linear-gradient(90deg, rgba(61, 104, 255, 0.12), #ffffff);
      background: #D9E6FD;
    }
  }

  .car-item__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .driver-name {
    font-size: 16px;
    font-weight: 600;
    color: #1f2b4d;
  }

  .status-tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 68px;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    border: 1px solid transparent;
    color: #4b5563;
    background: rgba(148, 163, 184, 0.15);

    &--warning {
      color: #f59e0b;
      background: rgba(245, 158, 11, 0.12);
      border-color: rgba(245, 158, 11, 0.2);
    }

    &--processing {
      color: #2563eb;
      background: rgba(37, 99, 235, 0.12);
      border-color: rgba(37, 99, 235, 0.22);
    }

    &--success {
      color: #16a34a;
      background: rgba(22, 163, 74, 0.16);
      border-color: rgba(22, 163, 74, 0.24);
    }
  }

  .car-meta {
    font-size: 13px;
    color: #5b6686;
    display: flex;
    align-items: center;
    gap: 6px;

    &.phone {
      font-weight: 500;
      color: #2b3a5d;
    }

    &.license {
      color: #2563eb;
      font-weight: 600;

      i {
        font-size: 16px;
      }
    }
  }
}

.car-empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #8a94b2;
  background: rgba(246, 249, 255, 0.6);
  border-radius: 12px;
}
</style>
